function isGeneralsubject(group)
{
    return group.title.toLowerCase() === 'algemeen';
}

export { isGeneralsubject };